export default __webpack_public_path__ + "static/media/coin.6e2ee0bc.jfif";